// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"08dae716ba4dad4b","1836":"fdd5f66e4e35dcb6","5735":"beb578cc985d134d"}[chunkId] + ".css";
};